import { render, staticRenderFns } from "./PendingPayments.vue?vue&type=template&id=794b5e92&scoped=true&"
import script from "./PendingPayments.vue?vue&type=script&lang=js&"
export * from "./PendingPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b5e92",
  null
  
)

export default component.exports